'use client'

import Header from '@/components/header/Header'
// import logoMain from '@/assets/img/logo-main.svg'
import React, { useEffect } from 'react'
import Link from 'next/link'
import NewsBanner from '@/components/news/NewsBanner'
import MainSlider from '@/components/main/MainSlider'
import materialsSettings from '@/assets/data/main-materials-slider.json'
import Megaschool from '@/components/Megaschool/Megaschool'
import Footer from '@/components/Footer/Footer'
import ForFarmers from '@/components/ForFarmers'
import OutArticles from '@/components/OurArticles'
import { useGetAllMaterialsQuery, useGetMaterialsCategoriesQuery } from '@/redux/services/materialsApi'
import { setResetCatalogFilters, setResetMaterialsFilters, setResetNewsFilters } from '@/redux/features/filterSlice'
import { useDispatch } from 'react-redux'
import MainSceneWithWrapper from '@/components/MainSceneWithWrapper/MainSceneWithWrapper'
import Calendar from '@/components/Calendar/Calendar'
import CardSlider from '@/components/CardSlider'
import { useTranslation } from 'react-i18next'
import { useGetAllNewsQuery } from '@/redux/services/newsApi'

const headSliderList = ['миссия', 'новости', 'статьи']

const mediaItem = {
    items: [
        {
            title: 'Медиацентр',
            text: [
                'Успех «МЕГАМИКС» сформировался на протяжении долгих лет. Специалисты по кормлению, ветеринарные врачи компании и менеджеры холдинга – это сотрудники с многолетним опытом работы.',
                'Здесь вы найдете актуальную информацию о новостях и событийной жизни компании, а также результаты исследований, статьи с рекомендациями для фермеров и медиаматериалы от «МЕГАШКОЛЫ» – образовательного проекта для фермеров в формате видеолекций. Заглядывайте сюда почаще – будет интересно.'
            ],
            cardClass: 'product__slide'
        },
        {
            title: 'Новости',
            text: [
                'Здесь вы всегда найдете информацию о событийной и исследовательской деятельности компании. Пост-релизы об участии в выставках и специализированных мероприятиях, а также пресс-релизы о выпуске новой продукции и достижениях компании. '
            ],
            cardClass: 'product__slide'
        },
        {
            title: 'Статьи',
            text: [
                'Следуя пути высоких технологий, «МЕГАМИКС» проводит различные исследования и разрабатывает новые продукты, направленные на увеличение эффективности животноводства. Здесь вы всегда найдете результаты научных исследований, практические рекомендации и советы от специалистов в области животноводства, которые помогут вам в поле вашей деятельности.'
            ],
            cardClass: 'product__slide'
        }
    ],
    btn: {
        content: 'Подробнее',
        link: '/media/#news-banner',
        icon: 'details'
    }
}

const MediaModule = () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    useEffect(() => {
        dispatch(setResetNewsFilters())
        dispatch(setResetMaterialsFilters())
        dispatch(setResetCatalogFilters())
    }, [])

    const { data: materialsCategoriesData } = useGetMaterialsCategoriesQuery()
    const { data: news } = useGetAllNewsQuery({ page: 0, count: 6 })

    return (
        <main className='main media'>
            {/* <div className='home__light-blue'></div>
            <div className='home__purple-1'></div>
            <div className='home__purple-2'></div>
            <div className='home__violet'></div> */}
            <Header burgerBg='linear-gradient(180deg, #3156A8 21.87%, #2D3079 108.55%)' />
            <MainSceneWithWrapper
                bottomBlur={true}
                zInx={5}
            />
            <div className='container'>
                <div className='media__top'>
                    {/* <Image className='media__bg' src={bgImage} width={581} height={544} quality={100} alt='media-bg' /> */}
                    <Link
                        style={{ zIndex: 5 }}
                        href={'/#map-cards'}
                    >
                        <button className='buttons buttons__maps'>
                            <svg
                                width='19'
                                height='19'
                                viewBox='0 0 19 19'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <g opacity='0.6'>
                                    <path
                                        d='M1 3.34483L5.95833 1V15.6552L1 18V3.34483Z'
                                        stroke='#CBD9F9'
                                        strokeWidth='1.6'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                    <path
                                        d='M12.3334 3.34483L18 1V15.6552L12.3334 18V3.34483Z'
                                        stroke='#CBD9F9'
                                        strokeWidth='1.6'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                    <path
                                        d='M12.3334 3.34483L5.95837 1V15.6552L12.3334 18V3.34483Z'
                                        stroke='#CBD9F9'
                                        strokeWidth='1.6'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                </g>
                            </svg>
                            Назад к карте
                        </button>
                    </Link>
                    {/* <FullProdSlider list={mediaItem} page='media' link='/media/#news-banner' headSlider={headSliderList} zIndex={6} /> */}
                    <CardSlider
                        list={mediaItem}
                        headSlider={headSliderList}
                    />
                </div>
                <div
                    className='news__section'
                    id='news-banner'
                >
                    <h2 className='main__section-title'>{t('news')}</h2>
                    <Link
                        href='/news'
                        className='useful-materials__link'
                        style={{ zIndex: 9999999 }}
                    >
                        <p>{t('watchAll')}</p>
                        <svg
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M9 15L12.9409 10.5664C12.9746 10.5285 12.9746 10.4715 12.9409 10.4336L9 6'
                                stroke='#83A3EB'
                                strokeWidth='2'
                                strokeLinecap='round'
                            />
                        </svg>
                    </Link>
                    {news ? <NewsBanner existedData={news} /> : null}
                </div>
                <Calendar />
                <h2 className='main__section-title'>{t('usefulMaterialsTitle')}</h2>
            </div>
            {materialsCategoriesData && (
                <MainSlider
                    settings={materialsSettings}
                    type={'useful-materials'}
                    list={materialsCategoriesData}
                />
            )}
            <div className='container'>
                <Megaschool type='megaschool' />
                <ForFarmers />
                <OutArticles />
            </div>
            <Footer />
        </main>
    )
}

export default MediaModule
